import React from "react";
import TMSIframe from "../iframe-component/TMSIframe";

const Devices = () => {
  return <TMSIframe path="/devices" />;
};

export default React.memo(Devices);
